import _ from 'lodash'
import Sorter from 'scoreboard/components/sorter'
import SortToggler from 'scoreboard/components/sort-toggler'
import SortableTableView from './sortable-table-view'
import streamLoader from 'scoreboard/components/export/stream-loader'
import arrayStream from 'stream-array'
import Chunker from 'scoreboard/components/chunker'

/**
 * Similiar to SortableTableView with the exception that this view is designed to work with data
 * that is streamed, whereas the aforementioned view does not
 */
let SortableStreamedTableView = SortableTableView.extend({

	initialize: function(options = {}) {
		this.options = options
		this.sortToggler = new SortToggler(options, this._initSortToggler.bind(this))
		this.observeStream(this.options.stream)
		this.disable(this.options.disabled)
	},

	/**
	 * Many views that require sorting involve streaming data, this method allow this view
	 * to inspect the stream to support sorting the data.
	 */
	observeStream: function(stream = null, initialData = []) {
		if (!stream) return

		// if this stream is not the sorted stream, then it must be from the
		// server so capture the entire data set for sorting
		if (!!stream.sorted == false) {
			//unbind the previous loader if any
			if (this.stream && this.streamLoader && _.isFunction(this.stream.removeListener)) {
				this.stream.removeListener('data', this.streamLoader)
			}
			this.allDataLoaded = false
			this.allData = [].concat(initialData)
			this.streamLoader = (data) => {
				this.allData = this.allData.concat(data)
			}
			stream.on('data', this.streamLoader)
		}
		this.stream = stream
	},

	applySort: function() {
		let state = this.sortToggler.state()

		//load all the data if not already done
		if (!!this.allDataLoaded == false) {
			let currentStream = this.stream
			streamLoader(this, this.stream, () => {
				//while waiting for the rest of the stream to load, we may have
				//been given an new updated stream to sort. If so wait for the
				//data in the new stream as that will be the most recent data we
				//need to use for sorting
				this.allDataLoaded = currentStream === this.stream
				this.applySort()
			})
			return
		}

		let useDefault = _.isNil(state.sortField)
		if (useDefault && _.isFunction(this.options.defaultSort)) {
			this.trigger('sorted', this.options.defaultSort(state))
			return
		} else {
			if (useDefault) {
				state.ascending = _.get(this.options, 'defaultSortAscending', true)
			}
		}

		let sorterOpts = this._prepSorterOptions(state)
		let data
		if (_.isFunction(this.options.filter)) {
			data = _.filter(this.allData, this.options.filter)
		} else {
			data = this.allData
		}
		new Sorter(sorterOpts)
			.on('done', (results) => {
				if (_.isFunction(this.options.postSort)) {
					results = this.options.postSort(results)
				}

				//chunk the sorted results
				let sortedStream = arrayStream(results)
				// don't use node's streams v3 internal buffer because
				// the chunker will buffer for us
				sortedStream.pause = _.noop

				let chunker = new Chunker(sortedStream)
				//identify this stream as the sorted one so we don't rebuild the full data set
				//since we already have it
				chunker.sorted = true

				// notify interested of the new sorted stream
				this.trigger('sorted', chunker)

				//start streaming to the chunker only after interested
				//parties are notified since they may need to do additional
				//setup before the data should be recieved
				sortedStream.pipe(chunker)
			})
			.sort(data, this._keyExtraction.bind(this))
	}

})

export default SortableStreamedTableView
SortableStreamedTableView.__filename__ = 'components/sortable-streamed-table-view.js'
